<template>
  <div>
    <template v-if="this.dataPieCharts != null">
      <v-row>
        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[0]") }}</h4>

          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[
                $t('home.dashboardChart.Charts2_PieChart.currentLoad.y1'), //
                $t('home.dashboardChart.Charts2_PieChart.currentLoad.y2'), //
                $t('home.dashboardChart.Charts2_PieChart.currentLoad.y3'), //
              ]"
              :value="[
                this.dataPieCharts.currentLoad[0] + 'kW', //
                this.dataPieCharts.currentLoad[1] + 'kW', //
                this.dataPieCharts.currentLoad[2] + 'kW', //
              ]"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.currentLoad"
              :color="
                $vuetify.theme.dark
                  ? [
                      this.customColors.dark.fromGrid[0],
                      this.customColors.dark.fromGrid[1],
                      this.customColors.dark.fromGrid[2],
                      this.customColors.dark.pv[0],
                      this.customColors.dark.pv[1],
                      this.customColors.dark.pv[2],
                      this.customColors.dark.fromBattery[0],
                      this.customColors.dark.fromBattery[1],
                      this.customColors.dark.fromBattery[2],
                    ]
                  : [
                      this.customColors.light.fromGrid[0],
                      this.customColors.light.fromGrid[1],
                      this.customColors.light.fromGrid[2],
                      this.customColors.light.pv[0],
                      this.customColors.light.pv[1],
                      this.customColors.light.pv[2],
                      this.customColors.light.fromBattery[0],
                      this.customColors.light.fromBattery[1],
                      this.customColors.light.fromBattery[2],
                    ]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>

        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[1]") }}</h4>
          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[
                $t('home.dashboardChart.Charts2_PieChart.pv.y1'), //
                $t('home.dashboardChart.Charts2_PieChart.pv.y2'), //
                $t('home.dashboardChart.Charts2_PieChart.pv.y3'), //
              ]"
              :value="[
                this.dataPieCharts.currentPV[0] + 'kW', //
                this.dataPieCharts.currentPV[1] + 'kW', //
                this.dataPieCharts.currentPV[2] + 'kW', //
              ]"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.currentPV"
              :color="
                $vuetify.theme.dark
                  ? [
                      this.customColors.dark.load[0],
                      this.customColors.dark.load[1],
                      this.customColors.dark.load[2],
                      this.customColors.dark.toGrid[0],
                      this.customColors.dark.toGrid[1],
                      this.customColors.dark.toGrid[2],
                      this.customColors.dark.toBattery[0],
                      this.customColors.dark.toBattery[1],
                      this.customColors.dark.toBattery[2],
                    ]
                  : [
                      this.customColors.light.load[0],
                      this.customColors.light.load[1],
                      this.customColors.light.load[2],
                      this.customColors.light.toGrid[0],
                      this.customColors.light.toGrid[1],
                      this.customColors.light.toGrid[2],
                      this.customColors.light.toBattery[0],
                      this.customColors.light.toBattery[1],
                      this.customColors.light.toBattery[2],
                    ]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[2]") }}</h4>
          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[
                $t('home.dashboardChart.Charts2_PieChart.load.y1'), //
                $t('home.dashboardChart.Charts2_PieChart.load.y2'), //
                $t('home.dashboardChart.Charts2_PieChart.load.y3'), //
              ]"
              :value="[
                this.dataPieCharts.todayLoad[0] + 'kWh', //
                this.dataPieCharts.todayLoad[1] + 'kWh', //
                this.dataPieCharts.todayLoad[2] + 'kWh', //
              ]"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.todayLoad"
              :color="
                $vuetify.theme.dark
                  ? [
                      this.customColors.dark.fromGrid[0],
                      this.customColors.dark.fromGrid[1],
                      this.customColors.dark.fromGrid[2],
                      this.customColors.dark.pv[0],
                      this.customColors.dark.pv[1],
                      this.customColors.dark.pv[2],
                      this.customColors.dark.fromBattery[0],
                      this.customColors.dark.fromBattery[1],
                      this.customColors.dark.fromBattery[2],
                    ]
                  : [
                      this.customColors.light.fromGrid[0],
                      this.customColors.light.fromGrid[1],
                      this.customColors.light.fromGrid[2],
                      this.customColors.light.pv[0],
                      this.customColors.light.pv[1],
                      this.customColors.light.pv[2],
                      this.customColors.light.fromBattery[0],
                      this.customColors.light.fromBattery[1],
                      this.customColors.light.fromBattery[2],
                    ]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>

        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[3]") }}</h4>
          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[
                $t('home.dashboardChart.Charts2_PieChart.pv.y1'), //
                $t('home.dashboardChart.Charts2_PieChart.pv.y2'), //
                $t('home.dashboardChart.Charts2_PieChart.pv.y3'), //
              ]"
              :value="[
                this.dataPieCharts.todayPV[0] + 'kWh', //
                this.dataPieCharts.todayPV[1] + 'kWh', //
                this.dataPieCharts.todayPV[2] + 'kWh', //
              ]"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.todayPV"
              :color="
                $vuetify.theme.dark
                  ? [
                      this.customColors.dark.load[0],
                      this.customColors.dark.load[1],
                      this.customColors.dark.load[2],
                      this.customColors.dark.toGrid[0],
                      this.customColors.dark.toGrid[1],
                      this.customColors.dark.toGrid[2],
                      this.customColors.dark.toBattery[0],
                      this.customColors.dark.toBattery[1],
                      this.customColors.dark.toBattery[2],
                    ]
                  : [
                      this.customColors.light.load[0],
                      this.customColors.light.load[1],
                      this.customColors.light.load[2],
                      this.customColors.light.toGrid[0],
                      this.customColors.light.toGrid[1],
                      this.customColors.light.toGrid[2],
                      this.customColors.light.toBattery[0],
                      this.customColors.light.toBattery[1],
                      this.customColors.light.toBattery[2],
                    ]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>
        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[4]") }}</h4>
          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[$t('home.dashboardChart.Charts2_PieChart.charging.y1'), $t('home.dashboardChart.Charts2_PieChart.charging.y2')]"
              :value="[this.dataPieCharts.todayCharging[0] + 'kWh', this.dataPieCharts.todayCharging[1] + 'kWh']"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.todayCharging"
              :color="
                $vuetify.theme.dark
                  ? [this.customColors.dark.fromGrid[0], this.customColors.dark.fromGrid[1], this.customColors.dark.fromGrid[2], this.customColors.dark.pv[0], this.customColors.dark.pv[1], this.customColors.dark.pv[2]]
                  : [this.customColors.light.fromGrid[0], this.customColors.light.fromGrid[1], this.customColors.light.fromGrid[2], this.customColors.light.pv[0], this.customColors.light.pv[1], this.customColors.light.pv[2]]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>

        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[5]") }}</h4>
          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[$t('home.dashboardChart.Charts2_PieChart.battery.y1'), $t('home.dashboardChart.Charts2_PieChart.battery.y2')]"
              :value="[this.dataPieCharts.todayBattery[0] + 'kWh', this.dataPieCharts.todayBattery[1] + 'kWh']"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.todayBattery"
              :color="
                $vuetify.theme.dark
                  ? [this.customColors.dark.toBattery[0], this.customColors.dark.toBattery[1], this.customColors.dark.toBattery[2], this.customColors.dark.fromBattery[0], this.customColors.dark.fromBattery[1], this.customColors.dark.fromBattery[2]]
                  : [this.customColors.light.toBattery[0], this.customColors.light.toBattery[1], this.customColors.light.toBattery[2], this.customColors.light.fromBattery[0], this.customColors.light.fromBattery[1], this.customColors.light.fromBattery[2]]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[6]") }}</h4>

          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[$t('home.dashboardChart.Charts2_PieChart.load.y1'), $t('home.dashboardChart.Charts2_PieChart.load.y2'), $t('home.dashboardChart.Charts2_PieChart.load.y3')]"
              :value="[
                this.dataPieCharts.prevDayLoad[0] + 'kWh', //
                this.dataPieCharts.prevDayLoad[1] + 'kWh', //
                this.dataPieCharts.prevDayLoad[2] + 'kWh', //
              ]"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.prevDayLoad"
              :color="
                $vuetify.theme.dark
                  ? [
                      this.customColors.dark.fromGrid[0],
                      this.customColors.dark.fromGrid[1],
                      this.customColors.dark.fromGrid[2],
                      this.customColors.dark.pv[0],
                      this.customColors.dark.pv[1],
                      this.customColors.dark.pv[2],
                      this.customColors.dark.fromBattery[0],
                      this.customColors.dark.fromBattery[1],
                      this.customColors.dark.fromBattery[2],
                    ]
                  : [
                      this.customColors.light.fromGrid[0],
                      this.customColors.light.fromGrid[1],
                      this.customColors.light.fromGrid[2],
                      this.customColors.light.pv[0],
                      this.customColors.light.pv[1],
                      this.customColors.light.pv[2],
                      this.customColors.light.fromBattery[0],
                      this.customColors.light.fromBattery[1],
                      this.customColors.light.fromBattery[2],
                    ]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>

        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[7]") }}</h4>

          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[$t('home.dashboardChart.Charts2_PieChart.pv.y1'), $t('home.dashboardChart.Charts2_PieChart.pv.y2'), $t('home.dashboardChart.Charts2_PieChart.pv.y3')]"
              :value="[
                this.dataPieCharts.prevDayPV[0] + 'kWh', //
                this.dataPieCharts.prevDayPV[1] + 'kWh', //
                this.dataPieCharts.prevDayPV[2] + 'kWh', //
              ]"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.prevDayPV"
              :color="
                $vuetify.theme.dark
                  ? [
                      this.customColors.dark.load[0],
                      this.customColors.dark.load[1],
                      this.customColors.dark.load[2],
                      this.customColors.dark.toGrid[0],
                      this.customColors.dark.toGrid[1],
                      this.customColors.dark.toGrid[2],
                      this.customColors.dark.toBattery[0],
                      this.customColors.dark.toBattery[1],
                      this.customColors.dark.toBattery[2],
                    ]
                  : [
                      this.customColors.light.load[0],
                      this.customColors.light.load[1],
                      this.customColors.light.load[2],
                      this.customColors.light.toGrid[0],
                      this.customColors.light.toGrid[1],
                      this.customColors.light.toGrid[2],
                      this.customColors.light.toBattery[0],
                      this.customColors.light.toBattery[1],
                      this.customColors.light.toBattery[2],
                    ]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>
        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[8]") }}</h4>
          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[$t('home.dashboardChart.Charts2_PieChart.charging.y1'), $t('home.dashboardChart.Charts2_PieChart.charging.y2')]"
              :value="[
                this.dataPieCharts.prevDayCharging[0] + 'kWh', //
                this.dataPieCharts.prevDayCharging[1] + 'kWh', //
              ]"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.prevDayCharging"
              :color="
                $vuetify.theme.dark
                  ? [this.customColors.dark.fromGrid[0], this.customColors.dark.fromGrid[1], this.customColors.dark.fromGrid[2], this.customColors.dark.pv[0], this.customColors.dark.pv[1], this.customColors.dark.pv[2]]
                  : [this.customColors.light.fromGrid[0], this.customColors.light.fromGrid[1], this.customColors.light.fromGrid[2], this.customColors.light.pv[0], this.customColors.light.pv[1], this.customColors.light.pv[2]]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>
        <v-col cols="12" lg="3" md="6" sm="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[9]") }}</h4>
          <template v-if="this.customColors != null">
            <AnyPieChart
              :label="[$t('home.dashboardChart.Charts2_PieChart.battery.y1'), $t('home.dashboardChart.Charts2_PieChart.battery.y2')]"
              :value="[
                this.dataPieCharts.prevDayBattery[0] + 'kWh', //
                this.dataPieCharts.prevDayBattery[1] + 'kWh', //
              ]"
              :dark="$vuetify.theme.dark"
              :data="this.dataPieCharts.prevDayBattery"
              :color="
                $vuetify.theme.dark
                  ? [this.customColors.dark.toBattery[0], this.customColors.dark.toBattery[1], this.customColors.dark.toBattery[2], this.customColors.dark.fromBattery[0], this.customColors.dark.fromBattery[1], this.customColors.dark.fromBattery[2]]
                  : [this.customColors.light.toBattery[0], this.customColors.light.toBattery[1], this.customColors.light.toBattery[2], this.customColors.light.fromBattery[0], this.customColors.light.fromBattery[1], this.customColors.light.fromBattery[2]]
              "
              :height="this.height"
              :width="this.width"
            />
          </template>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="3" md="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[10]") }}</h4>
        </v-col>
        <v-col cols="12" lg="3" md="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[11]") }}</h4>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="3" md="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[12]") }}</h4>
        </v-col>
        <v-col cols="12" lg="3" md="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[13]") }}</h4>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="3" md="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[14]") }}</h4>
        </v-col>
        <v-col cols="12" lg="3" md="6" align="center">
          <h4>{{ $t("home.dashboardChart.pieCharts.singleName[15]") }}</h4>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <LoadingData />
    </template>

    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

import { customColors } from "../../colors.js";
import AnyPieChart from "../../components/charts/AnyPieChart.vue";

import LoadingData from "../../components/LoadingData.vue";

import { ServiceClient } from "../../service_client/service_client.js";

export default {
  name: "Charts2",
  components: {
    AnyPieChart,
    LoadingData,
    UpgradeCore,
  },

  data() {
    return {
      timer: null,

      customColors: null,

      height: 280,
      width: 280,

      dataPieCharts: null,
    };
  },
  methods: {
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("chartpies"), null, null, "GET")
        .then((data) => {
          this.dataPieCharts = data;
        })
        .catch((error) => {
          this.dataPieCharts = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    pollData() {
      this.timer = setInterval(() => {
        this.getData();
      }, 2555);
    },
  },
  mounted() {
    this.customColors = customColors;
    this.getData();
  },
  created() {
    this.pollData();
  },
  beforeDestroy: function () {
    clearInterval(this.timer);
  },
};
</script>

<style scoped></style>
